const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/_settingsLayout/members/invitation_links/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/_settingsLayout/members/invitation_links/")({
  beforeLoad: ({
    location
  }) => {
    redirect({
      to: "/settings/invitation_links",
      replace: true,
      search: true,
      hash: true,
      state: location.state,
      throw: true
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});